<template>
  <div class="auto-login">
    <div class="loading">
      <van-loading type="spinner" size="24px" />
      <p>登录中...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AutoLogin',
  beforeRouteEnter(to, from, next) {
    let titleData = sessionStorage.getItem('title')
    if (!titleData) {
      // 没有授权参数，跳转到授权失败页
      next({ name: 'AuthFailed' })
      return
    }

    next((vm) => {
      sessionStorage.removeItem('title')
      let arr
      try {
        arr = JSON.parse(vm.$Base64.decode(titleData))
      } catch (e) {
        // a 参数不合法（无法解码/解析）-> 授权失败
        vm.$router.replace({ name: 'AuthFailed' })
        return
      }

      vm.$api.login.authLogin(arr).then(res => {
        if (res.code == 200) {
          localStorage.setItem('token', 'Bearer ' + res.data.token)
          localStorage.setItem('username', res.data.username)
          if (arr.seedName) {
            arr.seedname = arr.seedName
            delete arr.seedName
          }
          sessionStorage.setItem('a', JSON.stringify(arr))
          sessionStorage.setItem('type', arr.channel_id)

          // 跳转到目标页面
          const targetPath = sessionStorage.getItem('comePath') || '/'
          window.location.href = targetPath
        } else {
          // 授权登录失败（参数不对/账号异常）-> 授权失败
          vm.$router.replace({ name: 'AuthFailed' })
        }
      }).catch(() => {
        vm.$router.replace({ name: 'AuthFailed' })
      })
    })
  }
}
</script>

<style scoped>
.auto-login {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}
.loading {
  text-align: center;
}
.loading p {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}
</style>
